var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.8125H6.5625V6.5V3.375C6.5625 3.20241 6.70241 3.0625 6.875 3.0625H16.875C17.0476 3.0625 17.1875 3.20241 17.1875 3.375V13.375C17.1875 13.5476 17.0476 13.6875 16.875 13.6875H13.75H13.4375V14V17.125C13.4375 17.2976 13.2976 17.4375 13.125 17.4375H3.125C2.95241 17.4375 2.8125 17.2976 2.8125 17.125V7.125C2.8125 6.95241 2.95241 6.8125 3.125 6.8125H6.25ZM7.1875 6.5V6.8125H7.5H13.125C13.2976 6.8125 13.4375 6.95241 13.4375 7.125V12.75V13.0625H13.75H16.25H16.5625V12.75V4V3.6875H16.25H7.5H7.1875V4V6.5ZM3.75 7.4375H3.4375V7.75V16.5V16.8125H3.75H12.5H12.8125V16.5V7.75V7.4375H12.5H3.75Z",
    fill: "#090F0D",
    stroke: "#090F0D",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.7e1a9dbf53b4f7f5cd9f144f8b695f1f.svg";
export { ForwardRef as ReactComponent };